var map = {
	".": 161,
	"./": 161,
	"./index": 161,
	"./index.js": 161,
	"./router": 547,
	"./router.js": 547,
	"./storage": 548,
	"./storage.js": 548
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1092;


//////////////////
// WEBPACK FOOTER
// ./app/middleware .*
// module id = 1092
// module chunks = 0